import { jsx as e } from "react/jsx-runtime";
import { Switch as r } from "./index.es117.js";
import { Checkbox as o } from "./index.es25.js";
const m = {
  checkbox: /* @__PURE__ */ e(o, { variant: "gray", id: "", role: "menuitemcheckbox" }),
  "partial-checkbox": /* @__PURE__ */ e(o, { variant: "gray", isPartial: !0, id: "", role: "menuitemcheckbox" }),
  switch: /* @__PURE__ */ e(r, { role: "menuitemcheckbox" })
};
export {
  m as MULTI_TO_COMPONENT
};
//# sourceMappingURL=index.es5446.js.map
